import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '@/theme/scalingTokens';

export const usePlannerLeftNavStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '12.5rem',
    minWidth: '12.5rem',
    backgroundColor: tokens.colorNeutralBackground3,
    minHeight: '100vh',
    position: 'relative',
    boxSizing: 'border-box',
    transition: 'transform 0.2s ease, opacity 0.2s ease',
    [mq.tablet]: {
      position: 'fixed',
      top: '3rem',
      left: 0,
      bottom: 0,
      zIndex: 100,
      boxShadow: tokens.shadow16,
      transform: 'translateX(-100%)',
      opacity: 0,
      pointerEvents: 'none',
    },
  },
  rootOpen: {
    [mq.tablet]: {
      transform: 'translateX(0)',
      opacity: 1,
      pointerEvents: 'auto',
    },
  },
  overlay: {
    display: 'none',
    [mq.tablet]: {
      display: 'block',
      position: 'fixed',
      top: '3rem',
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: tokens.colorBackgroundOverlay,
      zIndex: 99,
    },
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: tokens.spacingVerticalXXS,
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalXS,
  },
  shadow: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '0.5rem',
    height: '100%',
    background: `linear-gradient(90deg, transparent 0%, ${tokens.colorNeutralStroke2} 100%)`,
    pointerEvents: 'none',
  },
  divider: {
    height: '0.0625rem',
    backgroundColor: tokens.colorNeutralStroke2,
    marginLeft: tokens.spacingHorizontalSNudge,
    marginRight: tokens.spacingHorizontalSNudge,
    marginTop: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalS,
  },
  sectionHeader: {
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase200,
    color: tokens.colorNeutralForeground2,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    height: '2rem',
    display: 'flex',
    alignItems: 'center',
  },
});
